import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Form, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Card from "../../components/Card";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaEye } from "react-icons/fa";
import SweetAlert from "react-bootstrap-sweetalert";
import RegistrasiService from "../../services/registrasi/RegistrasiService";
import ModalUPT from "../registrasi/modal/ModalUPT";
import ModalImg from "./modal/ModalImg";
import { format } from "date-fns";

const EditProfile = () => {
    const [propinsi, setPropinsi] = useState([]);
    const [kota, setKota] = useState([]);
    const [namaUPT, setNamaUPT] = useState("");
    const [kodeUptAwal, setKodeUptAwal] = useState("");
    const [kodeUPT, setKodeUPT] = useState("");
    const [showUPT, setShowUPT] = useState(false);
    const [showImg, setShowImg] = useState(false);
    const [second, setSecond] = useState(false);
    const [first, setFirst] = useState(false);
    const [pilihUPT, setPilihUPT] = useState(false);
    const [pilihService, setPilihService] = useState(false);
    const [selesai, setSelesai] = useState(false);
    const [trade, setTrade] = useState([]);
    const [layanFound, setLayananFound] = useState(false);
    const navigate = useNavigate();
    let RegService = useMemo(() => new RegistrasiService(), []);
    const [noLayanan, setNoLayanan] = useState(0);
    const [existTraderUpt, setExistTraderUpt] = useState(false);
    const [userID, setUserID] = useState("");
    const [jenisImg, setJenisImg] = useState("a");
    const [kdDokumen, setKdDokumen] = useState(0);

    const [trader, setTrader] = useState({
        JENIS_USAHA: null,
        NOMOR_KUSUKA: null,
        NAMA: null,
        NPWP: null,
        NO_IZIN: null,
        ALAMAT: null,
        PROPINSI: null,
        KOTA: null,
        KODEPOS: null,
        TELEPON: null,
        EMAIL: null,
        EMAIL_PNBP: null,
        KETERANGAN: null,
        TGL_DAFTAR: null,
        FILE_ID: "",
        STATUS: null,
        LAST_UPDATED: null,
    });

    // user
    const [user, setUser] = useState({
        ROLE: "4",
        KODE_TRADER: 0,
        USERNAME: "",
        PASSWORD: null,
        JNS_ID: "1",
        NO_ID: "",
        NAMA: "",
        ALAMAT: "",
        EMAIL: "",
        TELEPON: "",
        JABATAN: "",
        KD_UNIT: "1",
        STATUS: "0",
        STS_LOGIN: "0",
        DATE_LOGIN: null,
        IP_LOGIN: "",
        LAST_LOGIN: null,
        DATE_CREATED: null,
        USER_CREATED: 1,
        LAST_UPDATED: null,
        USER_UPDATED: 1,
    });

    // trader user
    const [traderUpt, setTraderUpt] = useState({
        KODE_TRADER: 0,
        KD_UNIT: "",
        KODE_TRADER_LOKAL: 0,
        STATUS: "",
        TGL_AKTIF: "",
        USER_UPDATE: 0,
        DATE_CREATED: "",
    })

    useEffect(() => {
        getTrader();
        getPropinsi();
    }, []);

    const getTrader = async () => {
        let kodeTrader = localStorage.getItem('kodeTrader')
        try {
            const responseTrader = await RegService.getTrader(kodeTrader)
            console.log(responseTrader.data);
            setTrader(responseTrader.data);
            setTrade(responseTrader.data);
            const resposeUser = await RegService.getUser(responseTrader.data.KODE_TRADER)
            setUser(resposeUser.data);
            const responseKota = await RegService.getKota(responseTrader.data.PROPINSI)
            setKota(responseKota.data);
            const responseUpt1 = await RegService.getKdUptByTrader(responseTrader.data.KODE_TRADER) //get trader upt
            if (responseUpt1.data != null) {
                const responseUpt2 = await RegService.getUptById(responseUpt1.data.KD_UNIT) //get upt
                setTraderUpt({ ...traderUpt, KODE_TRADER: responseTrader.data.KODE_TRADER });
                setExistTraderUpt(true);
                setTraderUpt(responseUpt1.data);
                setKodeUPT(responseUpt2.data.KD_UNIT)
                setNamaUPT(responseUpt2.data.NM_UNIT)
                setKodeUptAwal(responseUpt2.data.KD_UNIT)
            }
            const responseLayanan = await RegService.getLayanan(responseTrader.data.KODE_TRADER)
            if (responseLayanan.data != null) {
                setLayananFound(true);
                setNoLayanan(responseLayanan.data.KODE);
                if (responseLayanan.data.KODE_LAYANAN === "3") {
                    setFirst(true);
                    setSecond(true);
                } else {
                    if (responseLayanan.data.KODE_LAYANAN === "1") {
                        setFirst(true);
                    } else {
                        setSecond(true);
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getPropinsi = async () => {
        try {
            // setUser({ ...user, KODE_TRADER: 0 });
            const response = await RegService.getPropinsi()
            setPropinsi(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    function autoFormatNPWP(NPWPString) {
        try {
            var cleaned = ("" + NPWPString).replace(/\D/g, "");
            var match = cleaned.match(/(\d{0,3})?(\d{0,3})?(\d{0,3})?(\d{0,1})?(\d{0,3})?(\d{0,3})$/);
            return [
                match[1],
                match[2] ? "." : "",
                match[2],
                match[3] ? "." : "",
                match[3],
                match[4] ? "." : "",
                match[4],
                match[5] ? "-" : "",
                match[5],
                match[6] ? "." : "",
                match[6]].join("")
        } catch (err) {
            return "";
        }
    }

    const propinsiChange = async (e) => {
        try {
            const response = await RegService.getKota(e.target.value)
            setKota(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    const getKdUPT = () => {
        setUser({ ...user, KD_UNIT: kodeUPT });
        setTraderUpt({ ...traderUpt, KD_UNIT: kodeUPT });
    };

    const handleClickUPT = () => {
        setShowUPT(true);
    };

    const handleClickImg = (jnsImg, kdDok) => {
        setJenisImg(jnsImg);
        setKdDokumen(kdDok);
        setShowImg(true);
    };

    const handleChangeService = (value) => {
        if (value === "first") {
            if (!first) {
                console.log(value, "dicentang`");
            } else {
                console.log(value, "tidak dicentang`");
            }
            setFirst(!first);
        };

        if (value === "second") {
            if (!second) {
                console.log(value, "dicentang");
            } else {
                console.log(value, "tidak dicentang`");
            }
            setSecond(!second);
        };
    }

    const routeChange = () => {
        navigate("/dashboard");
    };

    const saveTrader = async (e) => {
        e.preventDefault();

        if (kodeUPT === "") {
            setPilihUPT(true);
            return
        }

        if (!first && !second) {
            setPilihService(true);
            return
        }

        try {
            await RegService.updateTrader(trader, trader.KODE_TRADER);
            await RegService.updateUser(user, user.USER_ID);
            if (!existTraderUpt) {
                await RegService.createTraderUPT({
                    KODE_TRADER: trader.KODE_TRADER,
                    KD_UNIT: kodeUPT,
                    KODE_TRADER_LOKAL: null,
                    STATUS: "2",
                    TGL_AKTIF: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    USER_UPDATE: localStorage.getItem('userId'),
                    DATE_CREATED: format(new Date(), 'yyyy-MM-dd HH:mm:ss')
                });
                setExistTraderUpt(false);
            } else {
                await RegService.updateTraderUPT({
                    KODE_TRADER: trader.KODE_TRADER,
                    KD_UNIT: kodeUPT,
                    STATUS: "2",
                    KODE_TRADER_LOKAL: null,
                    TGL_AKTIF: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    USER_UPDATE: localStorage.getItem('userId'),
                    DATE_CREATED: format(new Date(), 'yyyy-MM-dd HH:mm:ss')
                }, traderUpt.KODE_TRADER, kodeUptAwal);
            }
            if (layanFound) {
                if (first && second) {
                    await RegService.updateLayanan({
                        KODE_TRADER: user.KODE_TRADER,
                        KODE_LAYANAN: "3",
                        STS_VERIFIKASI: "1"
                    }, noLayanan);
                } else {
                    if (first) {
                        await RegService.updateLayanan({
                            KODE_TRADER: user.KODE_TRADER,
                            KODE_LAYANAN: "1",
                            STS_VERIFIKASI: "1"
                        }, noLayanan);
                    } else {
                        await RegService.updateLayanan({
                            KODE_TRADER: user.KODE_TRADER,
                            KODE_LAYANAN: "2",
                            STS_VERIFIKASI: "1"
                        }, noLayanan);
                    }
                }
            } else {
                if (first && second) {
                    await RegService.registrasiService({
                        KODE_TRADER: user.KODE_TRADER,
                        KODE_LAYANAN: "3",
                        STS_VERIFIKASI: "1"
                    });
                } else {
                    if (first) {
                        await RegService.registrasiService({
                            KODE_TRADER: user.KODE_TRADER,
                            KODE_LAYANAN: "1",
                            STS_VERIFIKASI: "1"
                        });
                    } else {
                        await RegService.registrasiService({
                            KODE_TRADER: user.KODE_TRADER,
                            KODE_LAYANAN: "2",
                            STS_VERIFIKASI: "1"
                        });
                    }
                }
            }
            setSelesai(true);
        } catch (error) {
            console.log(error);
        }
    };

    const handleTradeService = () => {
        setPilihService(false);
    }

    const handleCloseRegister = () => {
        setSelesai(false);
        navigate("/dashboard");
    };

    const handlePilihUPT = () => {
        setPilihUPT(false);
    }

    const handleCloseUPT = () => {
        setUser({ ...user, KD_UNIT: kodeUPT });
        setShowUPT(false);
    }

    const handleCloseImg = () => {
        setShowImg(false);
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card className="px-5 pt-5">
                        <Card.Header>
                            <div className="header-title">
                                <h4 className="card-title">Edit Profile</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            {/* <h2 className="mb-3 text-center">Form Registrasi</h2> */}
                            <h4 className="mb-5 text-center">
                                Data Umum Pengguna Jasa
                            </h4>
                            {/* <Form onSubmit={saveTrader}> */}
                            <Form onSubmit={saveTrader}>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark" htmlFor="npwp">
                                        {`NPWP Perusahaan*`}
                                    </Form.Label>
                                    <Col sm="3">
                                        <Row> 
                                            <Col> 
                                                <Form.Control type="text" name="npwp" id="npwp" pattern=".{21}" maxLength="{21}"
                                                    placeholder="NPWP Perusahaan 16 Digit" required value={trader.NPWP}
                                                    onChange={(e) => { setTrader({ ...trader, NPWP: e.target.value }) }}
                                                    onInput={(e) => { e.target.value = autoFormatNPWP(e.target.value); }}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col sm="1" className="align-self-center">
                                        <OverlayTrigger placement="bottom" overlay={
                                            <Tooltip >Lihat NPWP</Tooltip>
                                        }>
                                            <Button size="sm" variant="info" onClick={() => handleClickImg(trader.FILE_ID, 1)}>
                                                <FaEye />
                                            </Button>
                                        </OverlayTrigger>
                                    </Col>
                                    <Col sm="5">
                                        <Row>
                                            <Col>
                                                <Form.Control
                                                    type="file"
                                                    id="NPWPFile"
                                                // onChange={loadImageNPWP}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0"
                                        htmlFor="nmPerusahaan"
                                    >
                                        Nama Perusahaan*
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            id="nmPerusahaan"
                                            defaultValue=""
                                            type="Text"
                                            placeholder="Nama Perusahaan"
                                            value={trader.NAMA}
                                            // disabled={tradeFound ? true : false}
                                            onChange={(e) =>
                                                setTrader({ ...trader, NAMA: e.target.value })
                                            }
                                            required
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0"
                                        htmlFor="nmPemilik"
                                    >
                                        Nama User*
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            id="nmUser"
                                            type="Text"
                                            required
                                            placeholder="Nama User"
                                            value={user.NAMA}
                                            // disabled={tradeFound ? true : false}
                                            onChange={(e) =>
                                                setUser({ ...user, NAMA: e.target.value })
                                            }
                                            on
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0"
                                        htmlFor="jabatan"
                                    >
                                        Jabatan*
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            id="jabatan"
                                            type="Text"
                                            placeholder="Jabatan"
                                            value={user.JABATAN}
                                            // disabled={tradeFound ? true : false}
                                            onChange={(e) =>
                                                setUser({ ...user, JABATAN: e.target.value })
                                            }
                                            required
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0"
                                        htmlFor="noidentitas"
                                    >
                                        No. Identitas KTP/KITAS*
                                    </Form.Label>
                                    <Col sm="9">
                                        <Row>
                                            <Col sm="3">
                                                <select
                                                    className="form-select mb-3 shadow-none"
                                                    value={user.JNS_ID}
                                                    onChange={(e) =>
                                                        setUser({ ...user, JNS_ID: e.target.value })
                                                    }
                                                >
                                                    <option defaultValue>Pilih Identitas</option>
                                                    <option value="1">KTP</option>
                                                    <option value="2">SIM</option>
                                                    <option value="3">Kartu Keluarga</option>
                                                </select>
                                            </Col>
                                            <Col sm="7">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Nomor Identitas"
                                                    value={user.NO_ID}
                                                    // disabled={tradeFound ? true : false}
                                                    onChange={(e) =>
                                                        setUser({ ...user, NO_ID: e.target.value })
                                                    }
                                                    required
                                                />
                                            </Col>
                                            <Col sm="1" className="align-self-center">
                                                <OverlayTrigger placement="bottom" overlay={
                                                    <Tooltip >Lihat Identitas</Tooltip>
                                                }>
                                                    <Button size="sm" variant="info" onClick={() => handleClickImg(trader.FILE_ID, 2)}>
                                                        <FaEye />
                                                    </Button>
                                                </OverlayTrigger>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="12">
                                                <Form.Control
                                                    type="file"
                                                    id="KTPFile"
                                                // onChange={loadImageKTP}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0 text-dark"
                                        htmlFor="email"
                                    >
                                        Nomor Induk Berusaha (NIB)
                                    </Form.Label>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0 ps-5"
                                        htmlFor="nomor"
                                    >
                                        Nomor*
                                    </Form.Label>
                                    <Col sm="3">
                                        <Form.Control
                                            type="Text"
                                            placeholder="Nomor izin usaha"
                                            value={trader.NO_IZIN}
                                            // disabled={tradeFound ? true : false}
                                            onChange={(e) =>
                                                setTrader({ ...trader, NO_IZIN: e.target.value })
                                            }
                                            required
                                        />
                                    </Col>
                                    <Col sm="1" className="align-self-center">
                                        <OverlayTrigger placement="bottom" overlay={
                                            <Tooltip >Lihat NIB</Tooltip>
                                        }>
                                            <Button size="sm" variant="info" onClick={() => handleClickImg(trader.FILE_ID, 3)}>
                                                <FaEye />
                                            </Button>
                                        </OverlayTrigger>
                                    </Col>
                                    <Col sm="5">
                                        <Form.Control
                                            type="file"
                                            id="NIBFile"
                                        // onChange={loadImageNIB}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0 text-dark"
                                        htmlFor="addr_pengguna"
                                    >
                                        Alamat Pengguna Jasa
                                    </Form.Label>
                                </Form.Group>

                                {/* Alamat Rumah */}
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0 text-dark"
                                        htmlFor="addr_rumah"
                                    >
                                        Alamat Rumah
                                    </Form.Label>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-top mb-0 ps-5"
                                        htmlFor="penerbit"
                                    >
                                        Jalan / No / Rt / Rw
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            as="textarea"
                                            id="exampleFormControlTextarea1"
                                            rows="5"
                                            placeholder="Alamat Rumah"
                                            value={user.ALAMAT}
                                            // disabled={tradeFound ? true : false}
                                            onChange={(e) =>
                                                setUser({ ...user, ALAMAT: e.target.value })
                                            }
                                            required
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0 text-dark ps-5"
                                        htmlFor="email"
                                    >
                                        Pos Elektronik/Email*
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="Email"
                                            placeholder="Email Pengguna"
                                            value={user.EMAIL}
                                            // disabled={tradeFound ? true : false}
                                            onChange={(e) =>
                                                setUser({ ...user, EMAIL: e.target.value })
                                            }
                                            required
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0 ps-5"
                                        htmlFor="hand_rumah"
                                    >
                                        Nomor Handphone*
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="Text"
                                            placeholder="Nomor Handphone"
                                            value={user.TELEPON}
                                            // disabled={tradeFound ? true : false}
                                            onChange={(e) =>
                                                setUser({ ...user, TELEPON: e.target.value })
                                            }
                                            required
                                        />
                                    </Col>
                                </Form.Group>

                                {/* Alamat Kantor */}
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0 text-dark"
                                        htmlFor="addr_rumah"
                                    >
                                        Alamat Kantor
                                    </Form.Label>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-top mb-0  ps-5"
                                        htmlFor="addr_kantor"
                                    >
                                        Jalan / No / Rt / Rw
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            as="textarea"
                                            id="exampleFormControlTextarea1"
                                            rows="5"
                                            placeholder="Alamat Kantor"
                                            value={trader.ALAMAT}
                                            // disabled={tradeFound ? true : false}
                                            onChange={(e) =>
                                                setTrader({ ...trader, ALAMAT: e.target.value })
                                            }
                                            required
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0  ps-5"
                                        htmlFor="propinsi_kantor"
                                    >
                                        Propinsi*
                                    </Form.Label>
                                    <Col sm="9">
                                        <select
                                            className="form-select mb-3 shadow-none"
                                            value={trader.PROPINSI}
                                            // disabled={tradeFound ? true : false}
                                            onChange={(e) => {
                                                setTrader({
                                                    ...trader,
                                                    PROPINSI: e.target.value,
                                                });
                                                propinsiChange(e);
                                            }}
                                            required
                                        >
                                            <option defaultValue>Pilih Propinsi</option>
                                            {propinsi.map((item) => (
                                                <option value={item.KODE_PROPINSI}>
                                                    {item.URAIAN_PROPINSI}
                                                </option>
                                            ))}
                                        </select>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label  align-self-center mb-0  ps-5"
                                        htmlFor="kab_kota_kantor"
                                    >
                                        Kabupaten / Kota*
                                    </Form.Label>
                                    <Col sm="9">
                                        <select
                                            className="form-select mb-3 shadow-none"
                                            value={trader.KOTA}
                                            // disabled={tradeFound ? true : false}
                                            onChange={(e) =>
                                                setTrader({ ...trader, KOTA: e.target.value })
                                            }
                                            required
                                        >
                                            <option defaultValue>Pilih Kabupaten/Kota</option>
                                            {kota.map((item) => (
                                                <option value={item.KODE_KOTA}>
                                                    {item.URAIAN_KOTA}
                                                </option>
                                            ))}
                                        </select>
                                    </Col>
                                </Form.Group>
                                {/* <Form.Group as={Row} className="form-group">
                        <Form.Label
                          column
                          sm="3"
                          className="control-label  align-self-center mb-0 ps-5"
                          htmlFor="kel_kec_kantor"
                        >
                          Kel / Kec*
                        </Form.Label>
                        <Col sm="9">
                          <select className="form-select mb-3 shadow-none">
                            <option defaultValue>Pilih Kecamatan</option>
                            <option value="1101010">TEUPAH SELATAN</option>
                            <option value="1101020">SIMEULUE TIMUR</option>
                            <option value="1101021">TEUPAH BARAT</option>
                          </select>
                        </Col>
                      </Form.Group> */}
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0 ps-5"
                                        htmlFor="kd_pos_kantor"
                                    >
                                        Kode Pos
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="Text"
                                            placeholder="Kode Pos"
                                            value={trader.KODEPOS}
                                            // disabled={tradeFound ? true : false}
                                            onChange={(e) =>
                                                setTrader({ ...trader, KODEPOS: e.target.value })
                                            }
                                        // required
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0 ps-5"
                                        htmlFor="telp_kantor"
                                    >
                                        Telepon / Faksimili
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="Text"
                                            placeholder="Telepon Kantor"
                                            value={trader.TELEPON}
                                            // disabled={tradeFound ? true : false}
                                            onChange={(e) =>
                                                setTrader({ ...trader, TELEPON: e.target.value })
                                            }
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0 text-dark  ps-5"
                                        htmlFor="email_kantor"
                                    >
                                        Pos Elektronik / Email*
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="Email"
                                            placeholder="Email Kantor"
                                            value={trader.EMAIL}
                                            // disabled={tradeFound ? true : false}
                                            onChange={(e) =>
                                                setTrader({ ...trader, EMAIL: e.target.value })
                                            }
                                            required
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-top mb-0  ps-5"
                                        htmlFor="ket_kantor"
                                    >
                                        Keterangan
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            as="textarea"
                                            id="exampleFormControlTextarea1"
                                            rows="5"
                                            placeholder="Keterangan"
                                            value={trader.KETERANGAN}
                                            // disabled={tradeFound ? true : false}
                                            onChange={(e) =>
                                                setTrader({
                                                    ...trader,
                                                    KETERANGAN: e.target.value,
                                                })
                                            }
                                        />
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0 text-dark"
                                        htmlFor="addr_pengguna"
                                    >
                                        Unit Pelaksana Teknis
                                    </Form.Label>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0 text-dark ps-5"
                                        htmlFor="email_kantor"
                                    >
                                        UPT*
                                    </Form.Label>
                                    <Col sm="9">
                                        <Row>
                                            <Col sm="8">
                                                <Form.Control
                                                    type="Text"
                                                    placeholder="UPT"
                                                    value={namaUPT}
                                                    onChange={getKdUPT}
                                                    disabled={true}
                                                // required
                                                />
                                            </Col>
                                            <Col sm="1" className="align-self-center">
                                                <Button
                                                    size="sm"
                                                    variant="primary"
                                                    onClick={() => handleClickUPT()}
                                                >
                                                    <FaSearch />
                                                    {/* Pilih UPT */}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0 text-dark"
                                        htmlFor="user_login"
                                    >
                                        Data Userlogin
                                    </Form.Label>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0 text-dark ps-5"
                                        htmlFor="user_login"
                                    >
                                        User Name*
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="Text"
                                            placeholder="User Name"
                                            value={user.USERNAME}
                                            disabled={true}
                                            onChange={(e) =>
                                                setUser({ ...user, USERNAME: e.target.value })
                                            }
                                            required
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label
                                        column
                                        sm="3"
                                        className="control-label align-self-center mb-0 text-dark ps-5"
                                        htmlFor="jenis_layanan"
                                    >
                                        Jenis Layanan*
                                    </Form.Label>
                                    <Col sm="9">
                                        <Row>
                                            <Col>
                                                <Form.Check className="d-block">
                                                    <Form.Check.Input className="me-2" type="checkbox" defaultValue="" id="checkSMKHP" value={first} onChange={() => handleChangeService("first")} checked={first} />
                                                    <Form.Check.Label htmlFor="checkSMKHP">
                                                        Sertifikasi SMKHP
                                                    </Form.Check.Label>
                                                </Form.Check>
                                            </Col>
                                            <Col>
                                                <Form.Check className="d-block">
                                                    <Form.Check.Input className="me-2" type="checkbox" defaultValue="" id="checkPBUMKU" value={second} onChange={() => handleChangeService("second")} checked={second} />
                                                    <Form.Check.Label htmlFor="checkPBUMKU">
                                                        PB-UMKU
                                                    </Form.Check.Label>
                                                </Form.Check>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Form.Group>
                                {/* <Form.Group>
                                    <Form.Check className="mb-5 mt-5">
                                        <Form.Check.Input className="me-2" type="checkbox" defaultValue id="invalidCheck2" required />
                                        <Form.Check.Label htmlFor="invalidCheck2">
                                            Setuju dengan syarat dan ketentuan
                                        </Form.Check.Label>
                                    </Form.Check>
                                </Form.Group> */}
                                <div className="text-center ali mt-5">
                                    <Button type="submit" variant="btn btn-primary">
                                        Submit
                                    </Button>{" "}
                                    <Button
                                        type="button"
                                        variant="btn btn-danger"
                                        onClick={routeChange}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ModalUPT
                setKodeUPT={setKodeUPT}
                setNamaUPT={setNamaUPT}
                showUPT={showUPT}
                handleCloseUPT={handleCloseUPT}
            />
            <ModalImg
                setJenisImg={jenisImg}
                setKdDokumen={kdDokumen}
                showImg={showImg}
                handleCloseImg={handleCloseImg}
            />
            {
                pilihService &&
                <SweetAlert
                    title="Jenis Layanan Belum Dipilih"
                    danger
                    onConfirm={handleTradeService}
                    btnSize="sm"
                />
            }
            {
                selesai &&
                <SweetAlert
                    title="Data Tersimpan"
                    success
                    onConfirm={handleCloseRegister}
                    btnSize="sm"
                >
                    Data update tersimpan
                </SweetAlert>
            }
            {
                pilihUPT &&
                <SweetAlert
                    title="UPT belum dipilih"
                    danger
                    onConfirm={handlePilihUPT}
                    btnSize="sm"
                />
            }
        </>
    );
};

export default EditProfile;
